import _extends from "@babel/runtime/helpers/esm/extends";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { IS_BUILT_IN, getRootBasedUrl, isAbsoluteUrl, assertLeadingSlash } from '@resolve-js/core';
import { GenericError } from './errors';
import { connect, disconnect } from './subscribe';
import { request, VALIDATED_RESULT } from './request';
import { assertNonEmptyString } from './assertions';
import determineOrigin from './determine-origin';

function determineCallback(options, callback) {
  if (typeof options === 'function') {
    return options;
  }

  if (typeof callback === 'function') {
    return callback;
  }

  return null;
}

function isOptions(arg) {
  return arg && typeof arg !== 'function';
}

var _command = function command(context, cmd, options, callback) {
  var actualOptions = isOptions(options) ? options : undefined;
  var actualCallback = determineCallback(options, callback);

  var asyncExec = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var response;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return request(context, '/api/commands', cmd, actualOptions);

            case 2:
              response = _context.sent;
              _context.prev = 3;
              _context.next = 6;
              return response.json();

            case 6:
              return _context.abrupt("return", _context.sent);

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](3);
              throw new GenericError(_context.t0);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 9]]);
    }));

    return function asyncExec() {
      return _ref.apply(this, arguments);
    };
  }();

  if (!actualCallback) {
    return asyncExec();
  }

  asyncExec().then(function (result) {
    actualCallback(null, result, cmd);
  })["catch"](function (error) {
    actualCallback(error, null, cmd);
  });
  return undefined;
};

export { _command as command };

var isReadModelQuery = function isReadModelQuery(arg) {
  return arg && arg.resolver;
};

var _query = function query(context, qr, options, callback) {
  var requestOptions = {
    method: 'GET'
  };
  var viewModelDeserializer;

  if (!isReadModelQuery(qr)) {
    var viewModel = context.viewModels.find(function (model) {
      return model.name === qr.name;
    });

    if (viewModel && !viewModel.deserializeState[IS_BUILT_IN]) {
      viewModelDeserializer = viewModel.deserializeState;
    }
  }

  if (isOptions(options)) {
    var _options$method;

    requestOptions.method = (_options$method = options.method) !== null && _options$method !== void 0 ? _options$method : 'GET';
    requestOptions.middleware = options.middleware;
    requestOptions.queryStringOptions = options.queryStringOptions;
  }

  var actualCallback = determineCallback(options, callback);
  var queryRequest;

  if (isReadModelQuery(qr)) {
    var name = qr.name,
        resolver = qr.resolver,
        args = qr.args;
    queryRequest = request(context, "/api/query/" + name + "/" + resolver, args, requestOptions, viewModelDeserializer);
  } else {
    var _name = qr.name,
        _aggregateIds = qr.aggregateIds,
        _args2 = qr.args;
    var ids = _aggregateIds === '*' ? _aggregateIds : _aggregateIds.join(',');
    queryRequest = request(context, "/api/query/" + _name + "/" + ids, {
      args: _args2,
      origin: determineOrigin(context.origin)
    }, requestOptions, viewModelDeserializer);
  }

  var asyncExec = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var response, responseDate, subscriptionsUrl, _response$headers$get, responseSubscription, _JSON$parse, _url, _result2, _result, meta;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return queryRequest;

            case 2:
              response = _context2.sent;
              responseDate = response.headers.get('Date');

              if (responseDate) {
                _context2.next = 6;
                break;
              }

              throw new GenericError("\"Date\" header missed within response");

            case 6:
              subscriptionsUrl = null;

              if (!isReadModelQuery(qr)) {
                responseSubscription = (_response$headers$get = response.headers.get('X-Resolve-View-Model-Subscription')) !== null && _response$headers$get !== void 0 ? _response$headers$get : '{ "url": "" }';
                _JSON$parse = JSON.parse(responseSubscription), _url = _JSON$parse.url;
                subscriptionsUrl = _url;
              }

              _context2.prev = 8;

              if (!(VALIDATED_RESULT in response)) {
                _context2.next = 13;
                break;
              }

              _result = response[VALIDATED_RESULT];
              _context2.next = 17;
              break;

            case 13:
              _context2.next = 15;
              return response.json();

            case 15:
              _result = _context2.sent;

              if (viewModelDeserializer != null && _result != null && _result.data) {
                _result.data = viewModelDeserializer(_result.data);
              }

            case 17:
              meta = _extends({}, (_result2 = _result) == null ? void 0 : _result2.meta, {
                timestamp: Number(responseDate)
              });

              if (subscriptionsUrl != null) {
                meta.url = subscriptionsUrl;
              }

              return _context2.abrupt("return", _extends({}, _result, {
                meta: meta
              }));

            case 22:
              _context2.prev = 22;
              _context2.t0 = _context2["catch"](8);
              throw new GenericError(_context2.t0);

            case 25:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[8, 22]]);
    }));

    return function asyncExec() {
      return _ref2.apply(this, arguments);
    };
  }();

  if (!actualCallback) {
    return asyncExec();
  }

  asyncExec().then(function (result) {
    actualCallback(null, result, qr);
    return result;
  })["catch"](function (error) {
    actualCallback(error, null, qr);
    throw error;
  });
  return undefined;
};

export { _query as query };

var _subscribe = function subscribe(context, url, cursor, viewModelName, aggregateIds, handler, subscribeCallback, resubscribeCallback) {
  var subscribeAsync = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return connect(context, url, cursor, aggregateIds, handler, viewModelName, resubscribeCallback);

            case 2:
              return _context3.abrupt("return", {
                viewModelName: viewModelName,
                aggregateIds: aggregateIds,
                handler: handler
              });

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function subscribeAsync() {
      return _ref3.apply(this, arguments);
    };
  }();

  if (typeof subscribeCallback !== 'function') {
    return subscribeAsync();
  }

  subscribeAsync().then(function (result) {
    return subscribeCallback(null, result);
  })["catch"](function (error) {
    return subscribeCallback(error, null);
  });
  return undefined;
};

export { _subscribe as subscribe };

var _unsubscribe = function unsubscribe(context, subscription) {
  var viewModelName = subscription.viewModelName,
      aggregateIds = subscription.aggregateIds,
      handler = subscription.handler;

  var unsubscribeAsync = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (!(typeof handler !== 'function')) {
                _context4.next = 2;
                break;
              }

              return _context4.abrupt("return");

            case 2:
              _context4.next = 4;
              return disconnect(context, aggregateIds, viewModelName, handler);

            case 4:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function unsubscribeAsync() {
      return _ref4.apply(this, arguments);
    };
  }();

  return unsubscribeAsync();
};

export { _unsubscribe as unsubscribe };

var _getStaticAssetUrl = function getStaticAssetUrl(_ref5, assetPath) {
  var rootPath = _ref5.rootPath,
      staticPath = _ref5.staticPath,
      origin = _ref5.origin;
  assertNonEmptyString(staticPath, 'staticPath');
  assertNonEmptyString(assetPath, 'assetPath');

  if (isAbsoluteUrl(assetPath)) {
    return assetPath;
  }

  assertLeadingSlash(assetPath, 'assetPath');

  if (isAbsoluteUrl(staticPath)) {
    return "" + staticPath + assetPath;
  }

  return getRootBasedUrl(rootPath, "/" + staticPath + assetPath, origin);
};

var _getOriginPath = function getOriginPath(_ref6, path) {
  var rootPath = _ref6.rootPath,
      origin = _ref6.origin;
  assertNonEmptyString(path, 'path');

  if (isAbsoluteUrl(path)) {
    return path;
  }

  assertLeadingSlash(path, 'path');
  return getRootBasedUrl(rootPath, path, origin);
};

export var getClient = function getClient(context) {
  return {
    command: function command(cmd, options, callback) {
      return _command(context, cmd, options, callback);
    },
    query: function query(qr, options, callback) {
      return _query(context, qr, options, callback);
    },
    getStaticAssetUrl: function getStaticAssetUrl(assetPath) {
      return _getStaticAssetUrl(context, assetPath);
    },
    getOriginPath: function getOriginPath(path) {
      return _getOriginPath(context, path);
    },
    subscribe: function subscribe(url, cursor, viewModelName, aggregateIds, handler, subscribeCallback, resubscribeCallback) {
      return _subscribe(context, url, cursor, viewModelName, aggregateIds, handler, subscribeCallback, resubscribeCallback);
    },
    unsubscribe: function unsubscribe(subscription) {
      return _unsubscribe(context, subscription);
    }
  };
};
//# sourceMappingURL=client.js.map